
const digest = '041843b10fc816bc7af16b6c8c98dc63d336fa19c17c5b7a4237e1a77863b7df';
const classes = {"select":"_select_16wyc_1","option":"_option_16wyc_6","item":"_item_16wyc_6","nameWrapper":"_nameWrapper_16wyc_12","name":"_name_16wyc_12","star":"_star_16wyc_21","address":"_address_16wyc_27","rootName":"_rootName_16wyc_31","active":"_active_16wyc_40"};
const css = `._select_16wyc_1 {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3) !important;
  border-color: #1665d8 !important;
}

._option_16wyc_6 ._item_16wyc_6 {
  display: flex;
  flex-direction: column;
  padding: 6px 12px;
  position: relative;
}
._option_16wyc_6 ._item_16wyc_6 ._nameWrapper_16wyc_12 {
  display: flex;
  flex-direction: row;
}
._option_16wyc_6 ._item_16wyc_6 ._nameWrapper_16wyc_12 ._name_16wyc_12 {
  font-size: 14px;
  font-weight: 600;
  flex-grow: 1;
}
._option_16wyc_6 ._item_16wyc_6 ._nameWrapper_16wyc_12 ._star_16wyc_21 {
  width: 15px;
}
._option_16wyc_6 ._item_16wyc_6 ._nameWrapper_16wyc_12 ._star_16wyc_21 img {
  width: 100%;
}
._option_16wyc_6 ._item_16wyc_6 ._address_16wyc_27 {
  padding-top: 5px;
  font-size: 12px;
}
._option_16wyc_6 ._item_16wyc_6 ._rootName_16wyc_31 {
  padding-top: 5px;
  font-size: 12px;
  color: #787c88;
}
._option_16wyc_6 ._item_16wyc_6:hover {
  cursor: pointer;
  background: #d9e8fe;
}
._option_16wyc_6 ._item_16wyc_6._active_16wyc_40 {
  background: #0e7bf9;
  color: #ffffff;
}
._option_16wyc_6 ._item_16wyc_6._active_16wyc_40 ._rootName_16wyc_31 {
  color: #ffffff;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  